import { Box, Button, makeStyles } from "@material-ui/core";
import { ChangeEvent, useCallback, useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../store";
import { removeDisclosureTemplateLogoAsync, upsertDisclosureTemplateLogoAsync } from "../../../store/adviser";
import { Colors, DialogBox, SubtitleText } from "../../controls/helpers";

const LogoUpload = () => {
  const { disclosureTemplate, errors } = useAppSelector((state) => state.adviser);
  const [logo, setLogo] = useState<File | null>();
  const [imgUrl, setImgUrl] = useState<string>();
  const classes = useStyles();
  const [openErrorMsg, setOpenErrorMsg] = useState(false);
  const [openSaveTemplate, setOpenSaveTemplate] = useState(false);
  const inputFile = useRef<HTMLInputElement | null>(null);
  const [openConfirm, setOpenConfirm] = useState(false);
  const dispatch = useAppDispatch();

  const confirmRemove = useCallback(() => dispatch(removeDisclosureTemplateLogoAsync()), [dispatch]);

  const confirmUpload = useCallback((logo: File) => dispatch(upsertDisclosureTemplateLogoAsync({ data: logo, fileName: "logo" })), [dispatch]);

  const onRemoveLogo = useCallback(() => {
    setLogo(null);
    setOpenConfirm(false);
    confirmRemove();
  }, [confirmRemove]);

  const onUploadLogo = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      if (event.target.files) {
        setLogo(event.target.files[0]);
        confirmUpload(event.target.files[0]);

        if (inputFile.current) {
          inputFile.current.value = "";
        }
      }
    },
    [confirmUpload]
  );

  useEffect(() => {
    setImgUrl(disclosureTemplate?.logo ? "data:image;base64," + disclosureTemplate.logo : "");
  }, [disclosureTemplate]);

  useEffect(() => {
    if (errors) {
      setImgUrl("");
      setOpenErrorMsg(true);
      return;
    }

    logo && setImgUrl(URL.createObjectURL(logo));
  }, [errors, logo]);

  return (
    <>
      <DialogBox open={openSaveTemplate} ok={() => setOpenSaveTemplate(false)}>
        <SubtitleText black hideMarginBottom>
          You must save the Disclosure template before uploading a logo.
        </SubtitleText>
      </DialogBox>
      <DialogBox open={openErrorMsg} ok={() => setOpenErrorMsg(false)}>
        <SubtitleText black hideMarginBottom>
          {errors?.title}
        </SubtitleText>
      </DialogBox>
      <DialogBox open={openConfirm} cancel={() => setOpenConfirm(false)} ok={onRemoveLogo}>
        <SubtitleText black hideMarginBottom>
          Are you sure you want to remove the logo?
        </SubtitleText>
      </DialogBox>
      <Box textAlign="center" width="150px" height="150px" className={imgUrl ? classes.logoContainer : ""}>
        <input type="file" id="file" ref={inputFile} accept=".png,.jpg,.jpeg" style={{ display: "none" }} onChange={onUploadLogo} />
        {!!imgUrl && <img src={imgUrl} className={classes.logo} />}
        <Box py={1}>
          <Button
            onClick={() => (imgUrl ? setOpenConfirm(true) : !disclosureTemplate?.disclosureTemplateId ? setOpenSaveTemplate(true) : inputFile.current?.click())}
            variant="contained"
            color="primary"
            type="button"
            disableElevation
          >
            {imgUrl ? "Remove" : "Upload"} logo
          </Button>
        </Box>
      </Box>
    </>
  );
};

const useStyles = makeStyles(
  {
    logo: {
      borderRadius: "0.75rem",
      objectFit: "contain",
      width: "100%",
      height: "100%",
      maxWidth: 145,
      maxHeight: 145,
    },
    logoContainer: {
      border: `1px solid ${Colors.Grey}`,
      borderRadius: "0.75rem",
      padding: 5,
    },
  },
  { name: "LogoUpload" }
);

export default LogoUpload;
